module.exports = __webpack_public_path__ + "media/Adekunle-Gold-Something-Different.fc611245.mp3";